import React from 'react';
import '../styles/About.css'
import { FaLinkedin } from "react-icons/fa";
import { FaGithub } from "react-icons/fa";
import resume from '../assets/resume.pdf'

import img from '../assets/VinitaProfile.jpeg'

const About = () => {
  return (
    <div className="profile-card">
      <div className="profile-left">
        <img src={img} alt="Profile" className="profile-image" />
        <h1 className="profile-name">&lt;Vinita Israni&gt;</h1>
        <p className="profile-role">Full Stack Developer / Software Engineer (she/her)</p>
        <a href='Mailto: isranivinita74@gmail.com'> <button className="email-button">Email me</button></a>
        <div className="social-icons">
        <a href="https://www.linkedin.com/in/vinita-israni-0b704a219/"><FaLinkedin /></a>
        <a href="https://github.com/VinitaIsrani74"><FaGithub /></a>

        </div>
      </div>
      <div className="profile-right">
        <h2>&lt;/About Me&gt;</h2>
        <p>
        I am Vinita Israni, a software engineer with a Master’s degree in Computer Applications from CIITM. I have gained practical experience through two remote internships. The first one was with Null Class as a full-stack developer intern for six months, where I developed and maintained web applications. The second was with TopperWorld as a web developer intern for one month, where I further honed my web development skills.

To gain more hands-on experience, I have also worked on several personal projects. I am passionate about learning new technologies and improving my skills. I am now looking for a full-time position where I can contribute and grow as a software developer.
        </p>
        <div className="profile-buttons">
        <a href={resume} download='resume'><button className='resume-button'>Download Resume</button></a>
        
        </div>
      </div>
    </div>
  );
};

export default About